import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=111b01b1&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./add.css?vue&type=style&index=0&id=111b01b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111b01b1",
  null
  
)

export default component.exports